var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRounded = function SvgArrowRounded(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 30
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 0A2.5 2.5 0 0115 2.5v19.074l5.505-5.365a2.501 2.501 0 013.49 3.582l-9.75 9.5a2.503 2.503 0 01-3.49 0l-9.75-9.5a2.5 2.5 0 113.49-3.582L10 21.574V2.5A2.5 2.5 0 0112.5 0z",
    fillRule: "evenodd"
  })));
};
export default SvgArrowRounded;